import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import styles from './Nav.module.css'

export default function Nav() {
  const location = useLocation()
  const navigate = useNavigate()
  const isHome = location.pathname === '/'

  return (
    <header className={styles.header}>
      <nav className={styles.nav} aria-label='Main navigation'>
        <div className={styles.left}>
          {!isHome && (
            <button
              type='button'
              className={styles.iconButton}
              onClick={() => navigate(-1)}
              aria-label='Go back'
            >
              <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
                <polyline points='15 18 9 12 15 6' />
              </svg>
            </button>
          )}
          <Link to='/' className={styles.logo} aria-label='VerifyLink home'>
            <span className={styles.logoText}>VerifyLink</span>
          </Link>
        </div>
        <button
          type='button'
          className={styles.iconButton}
          onClick={() => navigate('/')}
          aria-label='Go home'
        >
          <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
            <path d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z' />
            <polyline points='9 22 9 12 15 12 15 22' />
          </svg>
        </button>
      </nav>
    </header>
  )
}
